// 同じページに残っている wuSiteResource2 側の旧実装（同期 <script> + jQuery(document).ready）が
// 先に走ることを保証してから fn を動かす。移設の過渡期（storefront.js と旧バンドルの両方が本番に乗る
// 数分〜数日）に、新旧の順序が入れ替わって二重に動くのを防ぐためのもの。
//
// storefront.js は defer なので、hook 本体は DOMContentLoaded（= jQuery ready）より前に走る。
// 旧実装の ready ハンドラより後ろに回るには load まで待ち、さらに 1 マクロタスク遅らせる:
// jQuery は評価時点で readyState が "complete" だと fn を setTimeout(jQuery.ready) で遅らせるため、
// load 直後ではまだ旧側の本体が動いていないことがある。同じ 0ms 遅延どうしは FIFO なので、
// こちらが後から積めば旧→新の順序が確定する（hooks/cart-betchu-shipping.ts で実証済みの作法）。
export function afterOldScripts(fn: () => void): void {
  const deferred = (): void => {
    window.setTimeout(fn, 0)
  }
  if (document.readyState === 'complete') {
    deferred()
  } else {
    window.addEventListener('load', deferred, { once: true })
  }
}
